import { useQuery, useMutation } from '@tanstack/react-query';
import Network from 'PREPAREsrc/service/Network';
import API from 'PREPAREsrc/service/api';

export const useUserTimeFormatQuery = (userId: string) => {
  return useQuery({
    queryKey: ['userTimeFormat', userId],
    queryFn: async () => {
      const response = await Network.get(API.userDetails, { userId });
      return response.data.response.dataset[0].timeFormat;
    },
  });
};

export const useUpdateUserTimeFormatMutation = () => {
  return useMutation({
    mutationFn: async ({
      userId,
      timeFormat,
      name,
    }: {
      userId: string;
      timeFormat: string;
      name: string;
    }) => {
      return Network.post(API.updateUserDetails, {
        userId,
        timeFormat,
        name,
      });
    },
  });
};
